import styles from './styles.module.scss';

type FormContainerProps = {
  children: React.ReactNode;
};

export const FormContainer = ({ children }: FormContainerProps) => {
  return <div className={styles.formContainer}>{children}</div>;
};
